import * as React from 'react';
import "./Footer.scss";
import { FooterProps } from './IFooter';

const Footer = (props: FooterProps) => {
  return (
    <div
      className="footer"
      style={{
        height: props.height,
        borderBottomLeftRadius: props.borderRadius,
        borderBottomRightRadius: props.borderRadius
      }}
    >
    </div>
  )
}

export default Footer;